import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LogoComponent } from '../logo/logo.component';
import { GoogleTagManagerService } from '../../../core/services/google-tag-manager.service';

type CtaVariant = 'Richiedi un contatto' | 'Richiedi info';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  imports: [LogoComponent],
})
export class PopupComponent {
  private vis = false;

  @Input()
  set visible(value: boolean) {
    this.vis = value;

    if (value) {
      this.setRandomCtaVariant();
    }
  }
  get visible(): boolean {
    return this.vis;
  }

  @Output() closed = new EventEmitter<void>();

  ctaLabel: CtaVariant = 'Richiedi un contatto';

  constructor(private gtm: GoogleTagManagerService) {}

  private setRandomCtaVariant() {
    const variants: CtaVariant[] = ['Richiedi un contatto', 'Richiedi info'];
    const randomIndex = Math.floor(Math.random() * variants.length);
    this.ctaLabel = variants[randomIndex];

    // Segnala a GTM quale variante è stata mostrata
    this.gtm.newEvent(
      this.ctaLabel === 'Richiedi un contatto'
        ? 'popup_cta_variant_contatto'
        : 'popup_cta_variant_piu_info'
    );
  }

  async handleWhatsappClick() {
    const message = encodeURIComponent(
      'Buongiorno! vorrei essere ricontattato per la dieta del mio cane'
    );

    window.open(`https://wa.me/+393520235596?text=${message}`, '_blank');

    this.gtm.newEvent(
      this.ctaLabel === 'Richiedi un contatto'
        ? 'click_whatsapp_cta_contatto'
        : 'click_whatsapp_cta_piu_info'
    );

    this.visible = false;
  }

  close() {
    this.visible = false;
    this.closed.emit();
  }
}
